interface DataLayerProps {
  featureName: string
  institution: string
}

export const DataLayerScripts = ({ institution, featureName }: DataLayerProps) => <div
  suppressHydrationWarning={true}
  dangerouslySetInnerHTML={{
    __html: `
      <script type="text/javascript">
        (() => {
          window['dataLayer'] = window['dataLayer'] || [];
          window['dataLayer'].push({
            pageName: '/ga-virtual/content-hub/${institution.formatString()}',
            pageType: 'content hub'
          });

          window['firstName'] = new Promise((resolve, _reject) => {
            const FIRST_NAME = 'first_name';

            window['dataLayer'].push = new Proxy(window['dataLayer'].push, {
              apply: (target, thisArg, [data]) => {
                data[FIRST_NAME] && resolve(data[FIRST_NAME]);

                return target.apply(thisArg, [data]);
              }
            });
          });
        })();
      </script>
      <!-- ZEPHR_FEATURE ${featureName} --><!-- ZEPHR_FEATURE_END ${featureName} -->
    `
  }}
/>;
